import { RoleTypeEnum } from 'api/account/membership/dtos';
import { LoadingSpinner } from 'components/loaders';
import { useAuth } from 'hooks';
import React from 'react';

interface RoleGuardProps {
  allowed: (RoleTypeEnum | null)[];
}

export const RoleGuard = ({ allowed, children }: React.PropsWithChildren<RoleGuardProps>) => {
  const { user } = useAuth();

  if (user == null) return <LoadingSpinner />;

  if (allowed.includes(user.role || null)) {
    return <>{children}</>;
  }

  return null;
};
